import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTenant} from '../App';
import {publicApi} from '../api';
import usePageTitle from '../hooks/usePageTitle';

export default function RequestLink() {
  const tenant = useTenant();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  usePageTitle('Check Application Status');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await publicApi('/ats/public/request-link', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({email, tenantId: tenant.id}),
    });
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow p-6 sm:p-8 fade-in">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Check Application Status</h1>
          <p className="text-gray-500 mb-6">Enter the email you used when applying and we'll send you a link to view your application.</p>

          {sent ? (
            <div className="text-center py-6 fade-in">
              <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-7 h-7 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-gray-900 font-medium mb-2">Check your inbox</p>
              <p className="text-gray-500 text-sm">If we found an application matching that email, you'll receive a link shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email Address <span className="text-red-500">*</span></label>
                <input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" placeholder="you@example.com"
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none transition-colors" />
              </div>
              <button type="submit" disabled={loading} className="w-full bg-teal-600 text-white py-2.5 rounded-lg hover:bg-teal-700 font-medium disabled:opacity-50 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2">
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />
                    Sending...
                  </span>
                ) : 'Send Link'}
              </button>
            </form>
          )}
        </div>
        <div className="text-center mt-4">
          <Link to="/" className="text-sm text-teal-600 hover:text-teal-800 focus:outline-none focus:underline">← Back to job board</Link>
        </div>
      </div>
    </div>
  );
}
